import { config } from "@/config";
import {
  IISolarBatteryOutlookResponse,
  IV1SolarBatteryOutlookSessionIdGetRequest,
  v1SolarBatteryOutlookSessionIdGet,
} from "@/contract/generated/electrify-v1";
import { useApi } from "@/hooks/useApi";
import { getSessionId, isError } from "@/utils";

interface IGetSolarBatteryResponse {
  error?: Error;
  result?: IISolarBatteryOutlookResponse[];
}

export const useSolarBattery = () => {
  const { call } = useApi();
  const getSolarBattery = async (): Promise<IGetSolarBatteryResponse> => {
    const data: IV1SolarBatteryOutlookSessionIdGetRequest = {
      sessionId: getSessionId(),
    };

    const response = await call(() =>
      v1SolarBatteryOutlookSessionIdGet(config.apiBasePath, data)
    );

    if (isError(response)) {
      return {
        error: response as Error,
      };
    }

    const result = response as IISolarBatteryOutlookResponse[];

    return {
      result,
    };
  };

  return {
    getSolarBattery,
  };
};
